import { createAction } from 'redux-actions';

export const setVenues = createAction('SET_VENUES');